export interface Work {
  id: string;
  title: string;
  titleJa: string;
  releaseDate: string;
  category: string;
  publisher: string;
  duration: string;
  coverImage: string;
  thumbImage: string;
  description: string;
}

export const categories = [
  { id: "all", name: "全部作品", nameJa: "すべて" },
  { id: "drama", name: "剧情系列", nameJa: "ドラマ" },
  { id: "romance", name: "恋爱系列", nameJa: "ロマンス" },
  { id: "office", name: "职场系列", nameJa: "オフィス" },
  { id: "featured", name: "精选推荐", nameJa: "おすすめ" },
];

export const works: Work[] = [
  {
    id: "work-001",
    title: "初めての体験 - 第一章",
    titleJa: "初めての体験 - 第一章",
    releaseDate: "2024-08-01",
    category: "drama",
    publisher: "S1 NO.1 STYLE",
    duration: "120分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20cinematic%20poster%20style%2C%20soft%20warm%20lighting%2C%20minimalist%20composition%2C%20romantic%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20soft%20rose%20and%20cream%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-001&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20cinematic%20poster%20thumbnail%2C%20soft%20warm%20lighting%2C%20minimalist%20composition%2C%20artistic%20film%20poster%20aesthetic%2C%20professional%20photography%20style&width=300&height=420&seq=work-thumb-001&orientation=portrait",
    description: "佐佐木明希在本作中饰演一位温柔的家庭教师，与学生之间发生的感人故事，展现了细腻的情感表达与精湛的演技。",
  },
  {
    id: "work-002",
    title: "禁断の関係 - 第二章",
    titleJa: "禁断の関係 - 第二章",
    releaseDate: "2024-07-15",
    category: "drama",
    publisher: "MOODYZ",
    duration: "150分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20cinematic%20drama%20poster%2C%20soft%20moody%20lighting%2C%20emotional%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20deep%20rose%20and%20warm%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-002&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20thumbnail%2C%20moody%20warm%20lighting%2C%20artistic%20film%20poster%20aesthetic%2C%20professional%20photography%20style&width=300&height=420&seq=work-thumb-002&orientation=portrait",
    description: "时隔三年的人气系列续作，佐佐木明希再度出演女主角，剧情更加扣人心弦，情感张力十足。",
  },
  {
    id: "work-003",
    title: "恋する気持ち - 特別編",
    titleJa: "恋する気持ち - 特別編",
    releaseDate: "2024-06-20",
    category: "romance",
    publisher: "PRESTIGE",
    duration: "130分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20cinematic%20poster%2C%20soft%20pastel%20lighting%2C%20cherry%20blossom%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20gentle%20pink%20and%20cream%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-003&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20poster%20thumbnail%2C%20soft%20pastel%20lighting%2C%20artistic%20film%20poster%20aesthetic%2C%20professional%20photography%20style&width=300&height=420&seq=work-thumb-003&orientation=portrait",
    description: "纯爱系列的特别篇，佐佐木明希以自然流畅的演技诠释了一段美好而令人心动的爱情故事。",
  },
  {
    id: "work-004",
    title: "オフィスラブ - 新入社員編",
    titleJa: "オフィスラブ - 新入社員編",
    releaseDate: "2024-05-10",
    category: "office",
    publisher: "IDEAPOCKET",
    duration: "140分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Office%20setting%20Japanese%20cinematic%20poster%2C%20clean%20professional%20lighting%2C%20modern%20corporate%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-004&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Office%20Japanese%20poster%20thumbnail%2C%20clean%20professional%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-004&orientation=portrait",
    description: "职场恋爱题材的全新力作，佐佐木明希饰演的新人OL与上司之间展开的办公室恋情，情节真实动人。",
  },
  {
    id: "work-005",
    title: "秘密の花園 - 完全版",
    titleJa: "秘密の花園 - 完全版",
    releaseDate: "2024-04-25",
    category: "romance",
    publisher: "S1 NO.1 STYLE",
    duration: "180分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Garden%20setting%20Japanese%20cinematic%20poster%2C%20soft%20natural%20lighting%2C%20dreamy%20floral%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20gentle%20rose%20and%20green%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-005&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Garden%20Japanese%20poster%20thumbnail%2C%20soft%20natural%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-005&orientation=portrait",
    description: "经典系列完全版，收录未公开场景与幕后花絮，是粉丝不可错过的珍藏之作。",
  },
  {
    id: "work-006",
    title: "都会の夜 - 東京編",
    titleJa: "都会の夜 - 東京編",
    releaseDate: "2024-03-18",
    category: "drama",
    publisher: "MOODYZ",
    duration: "125分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Tokyo%20night%20cityscape%20Japanese%20cinematic%20poster%2C%20moody%20neon%20and%20warm%20lighting%2C%20urban%20romantic%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20deep%20rose%20and%20navy%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-006&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Tokyo%20night%20Japanese%20poster%20thumbnail%2C%20moody%20urban%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-006&orientation=portrait",
    description: "以东京夜晚为舞台的都市情感剧，佐佐木明希展现了成熟女性的魅力与内心世界的复杂情感。",
  },
  {
    id: "work-007",
    title: "先輩と後輩 - 青春篇",
    titleJa: "先輩と後輩 - 青春篇",
    releaseDate: "2024-02-08",
    category: "romance",
    publisher: "PRESTIGE",
    duration: "135分钟",
    coverImage: "https://readdy.ai/api/search-image?query=School%20setting%20Japanese%20cinematic%20poster%2C%20bright%20youthful%20lighting%2C%20nostalgic%20classroom%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20warm%20cream%20and%20cherry%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-007&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=School%20Japanese%20poster%20thumbnail%2C%20bright%20youthful%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-007&orientation=portrait",
    description: "校园青春恋爱题材，佐佐木明希饰演温柔体贴的学姐，勾起了无数观众对学生时代的美好回忆。",
  },
  {
    id: "work-008",
    title: "女社長の憂鬱 - 完全版",
    titleJa: "女社長の憂鬱 - 完全版",
    releaseDate: "2024-01-20",
    category: "office",
    publisher: "IDEAPOCKET",
    duration: "160分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Executive%20office%20Japanese%20cinematic%20poster%2C%20sophisticated%20lighting%2C%20luxury%20corporate%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20warm%20golden%20and%20cream%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-008&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Executive%20Japanese%20poster%20thumbnail%2C%20luxury%20office%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-008&orientation=portrait",
    description: "佐佐木明希首次挑战女社长角色，干练强势的外表下隐藏着不为人知的柔情一面。",
  },
  {
    id: "work-009",
    title: "あなたに逢いたくて - 前編",
    titleJa: "あなたに逢いたくて - 前編",
    releaseDate: "2023-12-10",
    category: "featured",
    publisher: "S1 NO.1 STYLE",
    duration: "145分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Emotional%20Japanese%20cinematic%20poster%2C%20dramatic%20soft%20lighting%2C%20poignant%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20deep%20rose%20and%20soft%20gold%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-009&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Emotional%20Japanese%20poster%20thumbnail%2C%20dramatic%20soft%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-009&orientation=portrait",
    description: "年度精选力作前篇，佐佐木明希倾情演绎一段跨越时空的爱恋，演技达到新的巅峰。",
  },
  {
    id: "work-010",
    title: "あなたに逢いたくて - 後編",
    titleJa: "あなたに逢いたくて - 後編",
    releaseDate: "2023-12-25",
    category: "featured",
    publisher: "S1 NO.1 STYLE",
    duration: "155分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Touching%20Japanese%20cinematic%20poster%2C%20warm%20sunset%20lighting%2C%20emotional%20farewell%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20deep%20rose%20and%20amber%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-010&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Touching%20Japanese%20poster%20thumbnail%2C%20warm%20sunset%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-010&orientation=portrait",
    description: "年度精选力作后篇，感人至深的结局让无数粉丝泪目，被公认为佐佐木明希的代表作之一。",
  },
  {
    id: "work-011",
    title: "昼下がりの情事 - 特別編",
    titleJa: "昼下がりの情事 - 特別編",
    releaseDate: "2023-11-05",
    category: "drama",
    publisher: "MOODYZ",
    duration: "130分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Afternoon%20light%20Japanese%20cinematic%20poster%2C%20warm%20sunlit%20room%20lighting%2C%20intimate%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20soft%20golden%20and%20cream%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-011&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Afternoon%20Japanese%20poster%20thumbnail%2C%20warm%20sunlit%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-011&orientation=portrait",
    description: "经典人气系列的特别篇，佐佐木明希的演绎更加成熟自然，剧情细腻入微。",
  },
  {
    id: "work-012",
    title: "恋文 - 文芸作品",
    titleJa: "恋文 - 文芸作品",
    releaseDate: "2023-10-15",
    category: "featured",
    publisher: "PRESTIGE",
    duration: "170分钟",
    coverImage: "https://readdy.ai/api/search-image?query=Literary%20Japanese%20cinematic%20poster%2C%20vintage%20warm%20lighting%2C%20nostalgic%20letter%20writing%20atmosphere%2C%20artistic%20film%20poster%20aesthetic%2C%20sepia%20and%20cream%20tones%2C%20professional%20photography%20style%2C%20clean%20background&width=600&height=800&seq=work-cover-012&orientation=portrait",
    thumbImage: "https://readdy.ai/api/search-image?query=Vintage%20Japanese%20poster%20thumbnail%2C%20warm%20sepia%20lighting%2C%20artistic%20film%20poster%20aesthetic&width=300&height=420&seq=work-thumb-012&orientation=portrait",
    description: "文艺气息浓厚的独特作品，佐佐木明希展现了精湛的文学素养与艺术表现力。",
  },
];